import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { initiatePayment, requestPaymentGateway } from "../../utils/backend";
import { isGatewayCheckoutError, startPaymentCheckoutOnce } from "../../utils/gatewayCheckout";

import BottomMessagePopUp from "../../components/BottomMessagePopUp";

const MakePayment = () => {
    const [searchParams] = useSearchParams();
    const [errorMessage, setErrorMessage] = useState("");
    const [isErrorVisible, setIsErrorVisible] = useState(false);
    const showErrorMessage = (msg) => {
        setErrorMessage(msg);
        setIsErrorVisible(true);
    };
    const token = searchParams.get("token");
    const orderNumber = searchParams.get("orderNumber");

    useEffect(() => {
        const processPayment = async () => {
            if (!token || !orderNumber) {
                showErrorMessage("Missing token or order number.");
                return;
            }

            try {
                // The backend picks the gateway (Ansa-Support#113); iPay88 runs as before.
                await startPaymentCheckoutOnce(orderNumber, {
                    request: () => requestPaymentGateway(token, orderNumber),
                    payWithIpay88: async () => {
                        const paymentResponse = await initiatePayment(token, orderNumber);

                        if (paymentResponse) {
                            // Create a container to hold the HTML content
                            const container = document.createElement("div");
                            container.innerHTML = paymentResponse;

                            // Append the container to the document body
                            document.body.appendChild(container);

                            // Find the form and submit it
                            const form = container.querySelector("#ipay88Form");
                            if (form) {
                                form.submit();
                            } else {
                                showErrorMessage("Payment form is unavailable.");
                            }
                        } else {
                            showErrorMessage("Failed to retrieve payment script.");
                        }
                    },
                });
            } catch (error) {
                if (isGatewayCheckoutError(error)) {
                    // 409, 5xx, network or an untrusted answer: never fall back to iPay88.
                    showErrorMessage("Payment form is unavailable.");
                    return;
                }
                // console.error("Error during payment initialization:", error);
                // initiatePayment throws the response body (or the axios error when there is
                // none), so error.response is usually absent: reading it unguarded threw here
                // and left the customer on "Processing your payment..." for good.
                const serverMessage = error?.response?.data?.message ?? (error?.isAxiosError ? undefined : error?.message);
                showErrorMessage(typeof serverMessage === "string" && serverMessage ? serverMessage : "Failed to retrieve payment script.");
            }
        };

        processPayment();
    }, [token, orderNumber]);

    return (
        <div>
            {errorMessage ? (
                <p style={{ color: "red" }}>{errorMessage}</p>
            ) : (
                <p>Processing your payment...</p>
            )}
            {/* BottomMessagePopUp Component */}
            <BottomMessagePopUp
                message={errorMessage}
                type="error"
                isVisible={isErrorVisible}
                onClose={() => setIsErrorVisible(false)}
            />
        </div>
    );
};

export default MakePayment;
